export const REBAR = {
  types: {
    EUROCODE_2: 'eurocode-2',
    EUROCODE_2_FIRE: 'eurocode-2_fire',
    EUROCODE_2_SEISMIC: 'eurocode-2_seismic',
    VARIO_ADHESIVE_METHOD: 'vario_adhesive-method',
    AS3600: 'as3600',
    AS5216: 'as5216'
  }
};



// WEBPACK FOOTER //
// ./src/reducers/selectors/design/types.js